<template>
	<div class="sky-checkbox">
		<sky-suffix v-bind="$attrs" @search-click="search">
			<!-- 全选复选框 -->
			<el-checkbox
				v-if="isCheckAll"
				:indeterminate="isIndeterminate"
				v-model="checkAll"
				@change="handleCheckAllChange"
				:disabled="disabled"
				:class="{ noCheckClass: isNoCheck }"
				class="checkAllClass"
			>
				全部
			</el-checkbox>

			<!-- 复选框组 -->
			<el-checkbox-group
				v-model="checkedValues"
				@change="handleChange"
				v-bind="$attrs"
				:disabled="disabled"
				:class="{ noCheckClass: isNoCheck }"
			>
				<div
					style="display: inline-block; margin-right: 30px"
					v-for="(item, index) in list"
					:key="index"
					class="checkbox-item"
				>
					<el-tooltip
						effect="dark"
						:content="item.tip"
						placement="top"
						:disabled="setTipDisabled(item, index)"
					>
						<el-checkbox
							:label="item[props.value]"
							:disabled="item.disabled"
							:style="{ width: checkboxItemWidth }"
							:border="border"
						>
							{{ item[props.label] }}
						</el-checkbox>
					</el-tooltip>
				</div>
			</el-checkbox-group>

			<slot name="toolTips"></slot>
		</sky-suffix>
	</div>
</template>

<script>
import _ from 'lodash';
import SkySuffix from '../formComponents/SkySuffix.vue';
import formStore from '@/mixins/formStore.js';

export default {
	name: 'sky-checkbox',
	componentName: 'sky-checkbox',
	mixins: [formStore],
	components: {
		SkySuffix,
	},
	props: {
		name: {
			type: String,
			default: '',
		},
		value: {
			type: Array,
			default: () => [],
		},
		border: {
			type: Boolean,
			default: false,
		},
		isNoCheck: {
			type: Boolean,
			default: false,
		},
		isCheckAll: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		options: {
			type: Array,
			default: () => [],
		},
		checkboxItemWidth: {
			type: String,
			default: undefined,
		},
		props: {
			type: Object,
			default: () => ({
				label: 'label',
				value: 'value',
			}),
		},
	},
	data() {
		return {
			checkedValues: [],
			list: [],
			checkAll: false,
			isIndeterminate: false,
		};
	},
	watch: {
		// 外部选中值同步到内部
		value: {
			handler(newVal) {
				this.checkedValues = Array.isArray(newVal) ? [...newVal] : [];
				this.updateCheckAllStatus();
			},
			immediate: true,
			deep: true,
		},
		// 选项列表深监听，克隆并更新状态
		options: {
			handler() {
				this.list = _.cloneDeep(this.options);
				this.updateCheckAllStatus();
			},
			immediate: true,
			deep: true,
		},
	},
	computed: {
		// 过滤掉禁用项的可选值列表（第二版逻辑）
		availableValues() {
			return this.options.filter(item => !item.disabled).map(item => item[this.props.value]);
		},
	},
	methods: {
		search(e) {
			this.$emit('search-click', e);
		},

		// 复选框组选中变化
		handleChange(checkedValues) {
			this.$emit('input', [...checkedValues]);
			this.updateCheckAllStatus();
		},

		// 全选切换
		handleCheckAllChange(val) {
			const newCheckedValues = val ? [...this.availableValues] : [];
			this.checkedValues = newCheckedValues;
			this.$emit('input', newCheckedValues);
			this.isIndeterminate = false;
		},

		// 统一更新 全选/半选 状态（核心逻辑）
		updateCheckAllStatus() {
			const { checkedValues, availableValues } = this;
			const checkedCount = checkedValues.length;
			const totalCount = availableValues.length;

			if (totalCount === 0) {
				this.checkAll = false;
				this.isIndeterminate = false;
				return;
			}

			this.checkAll = checkedCount === totalCount;
			this.isIndeterminate = checkedCount > 0 && checkedCount < totalCount;
		},

		// 控制 Tooltip 显隐（第一版原有方法）
		setTipDisabled(val) {
			let { tip, tipDisabled } = val;
			if (!tip) return true;
			if (tipDisabled !== undefined) return tipDisabled;
			return false;
		},
	},
};
</script>

<style lang="scss" scoped>
.sky-checkbox {
	.toolFormItem {
		flex-direction: column;
		align-items: flex-start;
	}

	.noCheckClass {
		.el-checkbox__input {
			display: none;
		}
		.el-checkbox__label {
			padding-left: 0;
		}
		.el-checkbox + .el-checkbox {
			margin-left: 0;
			margin-right: 25px;
		}
	}

	.checkAllClass {
		height: 41px;
		margin-right: 15px;
		.el-checkbox__label {
			padding-left: 0;
		}
	}

	.item {
		margin-left: 4px;
	}
}
</style>
